import React from "react";

export default function AboutAnabel() {
  return (
    <div className="w-full bg-[#f8f9fc] py-16 lg:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        
        {/* ── HEADER SECTION ── */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-extrabold tracking-[0.2em] uppercase bg-[#e8e6fb] border border-[#1800ad] text-[#1800ad] px-4 py-1.5 rounded-full mb-4">
            ★ About Us
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Trusted Education Partner <span className="text-[#d11210]">Since 2008</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-500 max-w-2xl mx-auto">
            Empowering individuals through accessible, high-quality, and career-focused education for over 19+ years of experience.
          </p>
        </div>

        {/* ── INTRO & IMAGE GRID ── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          
          {/* Left: Text Content */}
          <div className="flex flex-col gap-6">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#1800ad]">
              Welcome to <span className="text-gray-900">Anabel Institute</span>
            </h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
              Established in 2008, Anabel Institute is a leading institution dedicated to providing quality education, teacher training, and online learning programs. With over <strong className="text-gray-900 font-bold">19+ years of experience</strong>, we have helped thousands of students build successful careers through job-oriented and flexible education solutions.
            </p>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
              We specialize in Nursery Teacher Training (NTT), Diploma Courses, Degree Programs, and Online & Distance Education, making education accessible to students, homemakers, and working professionals across India and abroad.
            </p>
            
            {/* Courses Pills */}
            <div className="mt-4">
              <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-3 border-b-2 border-[#ffde59] inline-block pb-1">
                Programs We Offer
              </h4>
              <div className="flex flex-wrap gap-2.5">
                {[
                  "Nursery Teacher Training (NTT)",
                  "Diploma & Certificate",
                  "Undergraduate (BA, B.Com, BBA, BCA)",
                  "Postgraduate (MA, M.Com, MBA, MCA)",
                  "Online & Distance Education"
                ].map(course => (
                  <span key={course} className="bg-white border border-gray-200 text-[#1800ad] font-semibold text-sm px-4 py-2 rounded-lg shadow-sm">
                    {course}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Image Grid */}
          <div className="relative">
            <div className="absolute inset-0 bg-[#d11210] rounded-3xl transform translate-x-4 translate-y-4 opacity-10"></div>
            <img 
              src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&auto=format&fit=crop&q=80" 
              alt="Students learning" 
              className="relative rounded-3xl shadow-xl w-full h-[400px] sm:h-[500px] object-cover border-4 border-white"
            />
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-[#ffde59] rounded-2xl p-5 shadow-lg border border-yellow-300 animate-bounce" style={{ animationDuration: '3s' }}>
              <p className="text-4xl font-black text-[#1800ad] mb-1">19+</p>
              <p className="text-sm font-bold text-[#d11210] uppercase tracking-wider">Years of Experience</p>
            </div>
          </div>
        </div>

        {/* ── MISSION & VISION ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          
          {/* Mission Card */}
          <div className="bg-white p-8 sm:p-10 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden group">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-[#d11210]"></div>
            <div className="absolute right-0 top-0 w-32 h-32 bg-red-50 rounded-full blur-3xl -mr-10 -mt-10 transition-transform group-hover:scale-110"></div>
            <div className="w-14 h-14 bg-red-50 text-[#d11210] rounded-xl flex items-center justify-center text-3xl mb-6 shadow-sm">
              🎯
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed relative z-10">
              Our mission is to empower individuals through affordable, flexible, and career-focused education, ensuring that every student gets the opportunity to succeed regardless of their background.
            </p>
          </div>

          {/* Vision Card */}
          <div className="bg-white p-8 sm:p-10 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden group">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-[#1800ad]"></div>
            <div className="absolute right-0 top-0 w-32 h-32 bg-blue-50 rounded-full blur-3xl -mr-10 -mt-10 transition-transform group-hover:scale-110"></div>
            <div className="w-14 h-14 bg-blue-50 text-[#1800ad] rounded-xl flex items-center justify-center text-3xl mb-6 shadow-sm">
              👁️
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed relative z-10">
              To become a top education institute in India by delivering high-quality, accessible, and innovative learning experiences that transform lives.
            </p>
          </div>

        </div>

        {/* ── WHY CHOOSE US ── */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#1800ad] inline-block border-b-4 border-[#ffde59] pb-2">
              Why Choose Anabel Institute?
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              "Established & Trusted Since 2008",
              "Flexible Online & Offline Learning Options",
              "Affordable Fees Structure",
              "Expert Faculty & Personal Guidance",
              "Career-Oriented Training Programs",
              "100% Support for Career Growth"
            ].map((reason, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-white p-5 rounded-xl border border-gray-100 hover:border-[#1800ad] transition-colors shadow-sm hover:shadow-md">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#ffde59] flex items-center justify-center text-[#1800ad] font-black text-sm shadow-sm mt-0.5">
                  ✓
                </div>
                <p className="text-base font-bold text-gray-800 leading-tight">
                  {reason}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ── CTA BANNER ── */}
        <div className="bg-[#1800ad] rounded-2xl overflow-hidden shadow-xl shadow-[#1800ad]/20 relative">
          <div className="absolute inset-0 opacity-10"
            style={{ backgroundImage: "repeating-linear-gradient(45deg,#fff 0,#fff 1px,transparent 0,transparent 50%)", backgroundSize: "16px 16px" }} />
          
          <div className="relative px-6 sm:px-12 py-10 sm:py-14 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
            <div className="max-w-2xl">
              <p className="text-sm font-bold uppercase tracking-widest text-[#ffde59] mb-3">
                Start Your Learning Journey Today
              </p>
              <h3 className="text-white font-extrabold text-2xl sm:text-3xl lg:text-4xl leading-tight mb-4">
                Take the first step toward a successful career in teaching, business, or professional fields.
              </h3>
              <p className="text-white/80 text-base sm:text-lg">
                Join Anabel Institute and transform your future.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center gap-6 shrink-0 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-sm">
              <div className="text-center sm:text-right">
                <p className="text-xs text-white/70 font-bold uppercase tracking-wider mb-1">Call / WhatsApp</p>
                <p className="text-[#ffde59] font-extrabold text-xl sm:text-2xl leading-tight">9964451828</p>
                <p className="text-[#ffde59] font-extrabold text-xl sm:text-2xl leading-tight mt-1">8884618113</p>
              </div>
              <a href="tel:9964451828" className="bg-[#d11210] hover:bg-[#a30e0c] text-white font-extrabold text-base px-8 py-4 rounded-xl transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap">
                Contact Us Now →
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}